export function monthRange() {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return { startDate: `${y}-${m}-01`, endDate: `${y}-${m}-${d}` }
}

export function money(v) {
  if (v == null || v === '') return '0.00'
  const n = Number(v)
  if (Number.isNaN(n)) return '0.00'
  return n.toFixed(2)
}

export function percent(v) {
  if (v == null || v === '') return '0.00%'
  const n = Number(v)
  if (Number.isNaN(n)) return '0.00%'
  return (n * 100).toFixed(2) + '%'
}

export function num(v) {
  const n = Number(v)
  return Number.isNaN(n) ? 0 : n
}

/** 下载报表导出的 xlsx blob */
export function downloadXlsx(blobData, filename) {
  const blob = new Blob([blobData], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

export function formatDateTime(v) {
  if (!v) return '-'
  const s = String(v)
  return s.length >= 16 ? s.slice(0, 16) : s
}
